var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mobileNav" },
    [
      _vm._t("button", function () {
        return [
          _c(
            "button",
            {
              staticClass: "mobileNav__button",
              class: _vm.buttonClass,
              on: { click: _vm.open },
            },
            [
              _c(
                "svg",
                {
                  staticClass: "mobileNav__icon",
                  attrs: {
                    viewBox: "0 0 24 24",
                    "stroke-width": "2",
                    stroke: "currentColor",
                    fill: "none",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                },
                [
                  _c("line", {
                    attrs: { x1: "4", y1: "6", x2: "20", y2: "6" },
                  }),
                  _vm._v(" "),
                  _c("line", {
                    attrs: { x1: "4", y1: "12", x2: "20", y2: "12" },
                  }),
                  _vm._v(" "),
                  _c("line", {
                    attrs: { x1: "4", y1: "18", x2: "20", y2: "18" },
                  }),
                ]
              ),
            ]
          ),
        ]
      }),
      _vm._v(" "),
      _c(
        "nav",
        { ref: "menu", staticClass: "mobileNav__menu" },
        [_vm._t("default")],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }